import { gql } from '@apollo/client';

export const GET_LOCATION_FEATURES_QUERY = gql`
    query GetLocationFeatures($locationId: ID!) {
        location(id: $locationId) {
            id
            features {
                dashboardV2
                enableNewAssetLibrary
                enableNewGalleryPage
                enableNewScheduledPage
                enableNewConnectPage
                showOldEmailTemplatesOption
                templateGalleryV2
                enableLocationDetailsV2
            }
        }
    }
`;
